var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3663 7.64666L8.69966 2.98C8.57105 2.85495 8.38549 2.80803 8.21289 2.85689C8.04029 2.90575 7.90687 3.04298 7.86289 3.21689C7.81891 3.39079 7.87105 3.57495 7.99966 3.7L11.8063 7.5H2.98633C2.71019 7.5 2.48633 7.72385 2.48633 8C2.48633 8.27614 2.71019 8.5 2.98633 8.5H11.7997L7.99966 12.3C7.90436 12.3929 7.85061 12.5203 7.85061 12.6533C7.85061 12.7864 7.90436 12.9138 7.99966 13.0067C8.09156 13.1031 8.21983 13.1563 8.353 13.1533C8.48571 13.154 8.61307 13.1011 8.70633 13.0067L13.373 8.34C13.568 8.14478 13.568 7.82854 13.373 7.63333L13.3663 7.64666Z",
    fill: "#0B1C3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow-Right.49d66133f69eb559212bbd404dd90ff2.svg";
export { ForwardRef as ReactComponent };